
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(058|25|354|384|610)|2(127|776|987)|5(449|566|751|919)|1(6(02|47|8)|185)|3(016|444|480|645|717)|6599|6888|8371|9859)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
